export default __webpack_public_path__ + "static/media/icon_word_cloud.f2ab0f8c.svg";